"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./Editor.scss");
const component_1 = require("./component");
const fileLoader_1 = require("../utils/fileLoader");
class Editor extends component_1.default {
    constructor(options) {
        super('editor');
        if (!window.ace) {
            console.log('Ace editor not found, add to a <script> tag.');
        }
        this.fileEl = document.createElement('div');
        this.fileEl.className = 'fileList';
        this.getEl().appendChild(this.fileEl);
        this.aceEl = document.createElement('div');
        this.aceEl.className = 'ace';
        if (window.ace) {
            this.ace = window.ace.edit(this.aceEl, {
                theme: 'ace/theme/monokai',
            });
        }
        this.getEl().appendChild(this.aceEl);
        if (options.loader) {
            this.loader = options.loader;
        }
        else {
            this.loader = new fileLoader_1.default();
        }
        if (options.root)
            this.loader.setRoot(options.root);
        if (options.directory) {
            this.loader.addDirectory(options.directory);
            this.render();
        }
        if (options.file) {
            const file = this.loader.addFile(options.file);
            this.showFile(file);
        }
    }
    showFile(file) {
        return __awaiter(this, void 0, void 0, function* () {
            file = yield this.loader.getFile(file);
            if (!file)
                return;
            if (file.ext === 'sfz') {
                const SfzMode = require('../lib/mode-sfz').Mode;
                this.ace.session.setMode(new SfzMode());
            }
            else {
                const modelist = window.ace.require('ace/ext/modelist');
                if (!modelist) {
                    window.alert('Ace modelist not found, add to a <script> tag.');
                }
                const mode = modelist.getModeForPath(file.path).mode;
                this.ace.session.setMode(mode);
            }
            this.ace.setOption('value', file.contents);
        });
    }
    createTree(root, files, filesTree) {
        const ul = document.createElement('ul');
        for (const key in filesTree) {
            let filePath = root + '/' + key;
            if (filePath.startsWith('/'))
                filePath = filePath.slice(1);
            const li = document.createElement('li');
            if (Object.keys(filesTree[key]).length > 0) {
                const details = document.createElement('details');
                const summary = document.createElement('summary');
                summary.innerHTML = key;
                details.appendChild(summary);
                details.appendChild(this.createTree(filePath, files, filesTree[key]));
                li.appendChild(details);
            }
            else {
                li.innerHTML = key;
                li.addEventListener('click', () => __awaiter(this, void 0, void 0, function* () {
                    yield this.showFile(files[filePath]);
                }));
            }
            ul.appendChild(li);
        }
        return ul;
    }
    render() {
        this.fileEl.replaceChildren();
        this.fileEl.innerHTML = this.loader.root;
        const ul = this.createTree('', this.loader.files, this.loader.filesTree);
        ul.className = 'tree';
        this.fileEl.appendChild(ul);
    }
    reset() {
        this.fileEl.replaceChildren();
        this.ace.setOption('value', '');
    }
}
exports.default = Editor;
